export default __webpack_public_path__ + "static/media/maintenanceBackgroundMB@2x.cc1364df.png";